import { render, staticRenderFns } from "./FancafeList.vue?vue&type=template&id=472023e2"
import script from "./FancafeList.vue?vue&type=script&lang=js"
export * from "./FancafeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports